import { ComponentProps, ComponentType, createElement } from 'react';

export const withProps = <T extends ComponentType<any>, P extends Partial<ComponentProps<T>>>(component: T, props: P) => {
  type InitialProps = ComponentProps<T>;
  type OmitProps = Omit<InitialProps, keyof P>;
  type PickedProps = Pick<InitialProps, keyof P>;
  type Props = Partial<PickedProps> & OmitProps;

  return (componentProps: Props) => {
    return createElement(component, { ...props, ...componentProps });
  };
};
